import {
  USERS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  USERS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  USERS_MASSIVE_UPLOAD_REQUEST_VERIFY,
  USERS_MASSIVE_UPLOAD_SET_VERIFY,
  USERS_MASSIVE_UPLOAD_CLEAR_VERIFY,
  USERS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  USERS_MASSIVE_UPLOAD_SET_UPLOAD,
  USERS_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function usersMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case USERS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case USERS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case USERS_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case USERS_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case USERS_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case USERS_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case USERS_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case USERS_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default usersMassiveUploadReducer;
